import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';
import SizeGuideModal from './SizeGuideModal';

const Gen3SizeGuideModal = () => {
  const { or3SizeGuideVisible, setOr3SizeGuideVisible, setOr3VideoVisible } =
    useSizingPageModalContext();
  const toggleModal = () => {
    setOr3SizeGuideVisible(false);
  };
  const onWatchVideoClick = () => {
    setOr3VideoVisible(true);
  };

  return (
    <SizeGuideModal
      description="or3_sizing_tips_subtitle"
      isOpen={or3SizeGuideVisible}
      onWatchVideoClick={onWatchVideoClick}
      steps={[
        {
          content: ['or3_sizing_tips_choose_finger_copy'],
          title: 'sizing_choose_finger_title',
        },
        {
          content: [
            'or3_sizing_tips_test_fit_copy_p1',
            'or3_sizing_tips_test_fit_copy_p2',
          ],
          title: 'sizing_test_fit_title',
        },
        {
          content: ['sizing_tips_confirm_size_copy'],
          cta: {
            href: '/my-account',
            label: 'confirm_your_size',
            size: 'large',
            variant: 'secondary-dark',
          },
          title: 'confirm_your_size',
        },
      ]}
      title="or3_sizing_tips_title"
      toggleModal={toggleModal}
    />
  );
};

export default Gen3SizeGuideModal;
